// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__w6Haq","paginationText":"Pagination_paginationText__poh8X","paginationCount":"Pagination_paginationCount__i3gOa"};